import api from "./api";

export const getRoles = async () => {
  const response = await api.get("/roles");
  return response.data;
};

export const getPermissions = async () => {
  const response = await api.get("/roles/permission");
  return response.data;
};

export const createRole = async (data: { name: string; description?: string; permissions: string[]; is_system?: boolean; company_id?: number; is_assignable_by_company?: boolean }) => {
  const response = await api.post("/roles", data);
  return response.data;
};

export const addPermissionsToRole = async (roleName: string, permissions: string[]) => {
  const response = await api.post("/roles/permissions/add", { roleName, permissions });
  return response.data;
};

export const addRoleToUser = async (userId: number, roleName: string) => {
  const response = await api.post("/roles/user", { userId, roleName });
  return response.data;
};

export const updateRole = async (id: number, data: { name: string; description?: string; permissions: string[] }) => {
  const response = await api.put(`/roles/${id}`, data);
  return response.data;
};

export const deleteRole = async (id: number) => {
  const response = await api.delete(`/roles/${id}`);
  return response.data;
};
